import { Subscription } from "../../../../services/subscription/types/subscription";
import { CallApi, handleJSONResponse } from "./common";

const callAPI = CallApi("subscriptions/admin");

export const getSubscription = async (
  clientId: string
): Promise<Subscription> => {
  const response = await callAPI(`/${clientId}`, "GET");

  return handleJSONResponse(response);
};
